<template>
<div >

<spinner v-bind:spinner='spinner'></spinner>

<!--
<div class="card border-success">
  <div class="card-header bg-success text-white">



   <h4> 
  <i class="fas fa-palette mr-2" aria-hidden="true"></i>  
  COLORI FORNITORE
   </h4>
  </div>
  <div class="card-body text-dark">
    -->

  <div class="table-responsive-sm mt-3">              
  <table class="table table-sm"  id="productSupplierColor">
    <thead class="thead-warning">
      <tr>
        <th>
           <i  class="fas fa-camera ml-2 " aria-hidden="true"></i>
        </th>
        <th>
           COLORE GESTIONALE
        </th>

        <th>
           COLORE FORNITORE
        </th>
        
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item,index) in items" :key="index">
        <td>{{item.productId}}-{{item.colorId}}</td>
        <td style="color: blue" >
          <strong>{{item.color}}</strong>
        </td>  
        <td >
        
            <input v-model = "item.supplierColor" class="form-control bold"  v-bind:id="'id_' + index " type="text">
          
        </td>

      </tr>
    </tbody>
  </table>
  
  
<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  <button :disabled="items.length==0" @click="submit()"  class="btn btn-primary float-right mt-2">
    <i class="fas fa-save mr-2" aria-hidden="true"></i>
    MODIFICA
    <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

  </button>
 
   
 </div>

</div>

<!--
</div>
</div> 
-->

</template>

<script>


import api                from "@/api"
import alertBox           from '@/components/common/AlertBox.vue';
import spinner            from '@/components/common/Spinner.vue';


export default {
   props : ['item'],
   components: {alertBox,spinner},  
  

  data () {
    return {      

      items           : [],    
      msg             : {
        title : ''
      },
      alert           : false,
      spinner         : false,
      

    }
  },
  computed: 
  {   
  },
   directives: 
    {

      focus: {
      
      inserted: function (el) 
      {
       
        //el.focus() 
      
      }
      
      }

    },
  mounted()
    {
        this.getData()
    },
  created()
  {
       
  },
  methods: 
  {
    async getData()
    {
    
    this.spinner  = true
    
    
    
    var data      = {'productId' : this.item.productId}
    var sp        = {'sp' : 'spProductSupplierColor'}
    var json      = Object.assign(data, sp);
    await api.post(json).then(res => {
          
          if(res.status==200)
            {
               
              this.items = res.data.recordsets[0]
              this.$nextTick().then(function () {
                  document.getElementById("id_0").focus();
                
               })

            }
           else if(res.status==500)
           {
                
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                
                
                this.msg.title = 'ATTENZIONE '  
                this.msg.body = res
                this.msg.type  = 1
                              
                 
            } 
          

          }).catch(err => {
              
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1
                
              
          }).finally(() => {
          this.spinner = false
        });
  
    
    },
    async submit()
    {
      var data                = {}
      data.body               = {}
      data.body               = this.items
      
      
      this.spinner  = true
      
      var sp        = {'sp' : 'spUpdateProductSupplierColor'}
      var json      = Object.assign(data, sp)


      await api.post(json).then(res => {
          
          

          if(res.status==200)
            {
                
                this.msg.title = "MODIFICA EFFETTUATA."
                this.msg.type  = 0
            }
           else if(res.status==500)
           {
               
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                            
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res
                this.msg.type  = 1
                 
            } 

        

          }).catch(err => {
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1   

              
          }).finally(() => {
          this.spinner = false
        });





    }
  
  
  }
  
   
  
}

</script>

<style scoped>
.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
  
    background   :  hwb(45 4% 9%); 
    color        : black;   
  
  
 }

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
    .bold
    {
        font-weight  : bold;
    }
    
    label{
      color  :  blue
    }
    p {
      font-family  : 'Roboto Condensed';
      font-size    : 25px;
    }
    span {
      font-family  : 'Roboto Condensed';
      font-size    : 15px;
    }
</style>